import React from "react";
import { useState, useEffect } from "react";
import { InputField, SelectInput, TextareaField, DatePickerField, AntdButton } from "../../../blueplanitUtils/InputField";
import { Row, Col, Card, Typography } from "antd";
import { Link } from "react-router-dom";
import { USER_ISSUES, ISSUE_STATUS } from "../../../Dropdownmanager";
import dayjs from "dayjs";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { getEmployeesListThunk } from "../../../Slices/Thunk/getemployeelist";
 
const AddIssueForm = ({
  formData,
  setFormData,
  assignToUsers,
  NestedDatabucket,
  LEAD_INFORMATION,
  PRIORITY,
  getAssignToUsers,
  getOptionsByPath,
  fileData,
  setFileData,
  fileInputRef,
  handleInputChange,
  handleMultipleAttachment,
  handleSubmit,
  isDisabled,
  onClose,
}) => {
 
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const [currentDateTime, setCurrentDateTime] = useState("");
 
  const dispatch = useDispatch();
 
  // const { list: employees, loading: empLoading } = useSelector(
  //   (state) => state.employees
  // );
  const employees = useSelector(
    (state) => state.employee.AllEmployees || []
  );
 
  console.log("Employees in AddIssueForm:", employees);
 
  const employeesOptions =
    employees.map((emp) => ({
      label: `${emp.firstname} ${emp.lastname}`,
      value: `${emp.firstname} ${emp.lastname}`,
    })) || [];
 
 
  // useEffect(() => {
  //   dispatch(getEmployeesListThunk());
  // }, [dispatch]);
 
 
 
  useEffect(() => {
    const now = dayjs().format("DD/MM/YYYY hh:mm A");
    setCurrentDateTime(now);
    const timer = setInterval(() => {
      setCurrentDateTime(dayjs().format("DD/MM/YYYY hh:mm A"));
    }, 1000);
    return () => clearInterval(timer);
  }, []);
 
  useEffect(() => {
    if (!formData?.CreatedBy && loginUser) {
      setFormData((prev) => ({
        ...prev,
        CreatedBy: `${loginUser.firstname || ""} ${loginUser.lastname || ""}`,
      }));
    }
  }, [loginUser]);
 
  return (
    <div className="page-wrapper">
      <form onSubmit={handleSubmit}>
        {/* Header with Back Button */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: -50,
            marginBottom: 20,
            paddingRight: 10,
            paddingLeft: 20,
            marginRight: 10,
          }}
        >
          <Typography.Title level={5} style={{ marginBottom: -40, marginLeft: 20, flex: 1, textAlign: 'left', fontWeight: "bold" }}>Add New Task</Typography.Title>
          <Row gutter={24} style={{ marginTop: "30px" }}>
            <Col span={24} style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <AntdButton
                  color="primary"
                  variant="solid"
                  htmlType="submit"
                  disabled={isDisabled}
                  label="Submit"
                  style={{
                    padding: "10px 30px",
                    fontSize: "14px",
                    maxWidth: "10px",
                  }}
                />
                <AntdButton
                  color="danger"
                  variant="solid"
                  onClick={onClose}
                  label="Close"
                  style={{
                    padding: "10px 30px",
                    fontSize: "14px",
                    maxWidth: "10px",
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>
 
        {/* Form Card */}
        <Card
          style={{
            marginLeft: 20,
            marginRight: 20,
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
          }}
        >
          <Row gutter={30}>
            <Col span={4}>
              <InputField
                label="Tab Name"
                type="text"
                name="Tabname"
                value={formData?.Tabname}
                onChange={handleInputChange}
                placeholder="Enter Tab Name"
              />
            </Col>
            <Col span={6}>
              <TextareaField
                label={<>Task Title <span style={{ color: "red" }}>*</span></>}
                name="TaskTitle"
                value={formData?.TaskTitle}
                onChange={handleInputChange}
                rows="1"
                placeholder="Enter Task Title"
              />
            </Col>
 
            <Col span={4}>
              <InputField
                label="Created Date"
                value={currentDateTime || ""}
                disabled
                style={{
                  fontWeight: "bold",
                  color: "#000",
                }}
              />
            </Col>
            <Col span={5}>
              <SelectInput
                label="Created By"
                options={employeesOptions}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                value={formData?.CreatedBy || `${loginUser?.firstname || ""} ${loginUser?.lastname || ""}`}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, CreatedBy: value }))
                }
                style={{ width: "100%" }}
                required
                placeholder="Select Created By"
              />
            </Col>
            <Col span={5}>
              <SelectInput
                label="Guided By"
                options={employeesOptions}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                value={formData?.GuidedBy || undefined}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, GuidedBy: value }))
                }
                style={{ width: "100%" }}
                placeholder="Select Guided By"
              />
            </Col>
            <Col span={4}>
              <SelectInput
                label="Priority"
                value={formData?.Priority || "Low"}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, Priority: value }))
                }
                className="form-control"
                required
                style={{ width: "100%" }}
                placeholder="Select Priority"
                dropdownStyle={{ zIndex: 10001 }}
                options={getOptionsByPath(
                  NestedDatabucket,
                  [LEAD_INFORMATION, PRIORITY]
                )}
              />
            </Col>
 
            <Col span={6}>
              <SelectInput
                label="Assigned To"
                options={employeesOptions}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                value={formData?.Assignedto || []}
                onChange={(value) =>
                  setFormData(prev => ({ ...prev, Assignedto: value }))
                }
                style={{ width: "100%" }}
                mode="multiple"
                required
                placeholder="Select Assigned To"
              />
 
            </Col>
            <Col span={4}>
              <DatePickerField
                label="Dead line"
                value={formData?.Deadline ? dayjs(formData.Deadline) : null}
                onChange={(date) =>
                  setFormData((prev) => ({
                    ...prev,
                    Deadline: date ? dayjs(date).format("YYYY-MM-DD") : null,
                  }))
                }
                format="DD/MM/YYYY"
                allowClear={false}
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
                style={{ width: "100%" }}
                placeholder="Select Deadline"
              />
            </Col>
            <Col span={5}>
              <SelectInput
                label="Task Status"
                value={formData?.Status || "Open"}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, Status: value }))
                }
                className="form-control"
                style={{ width: "100%" }}
                required
                dropdownStyle={{ zIndex: 10001 }}
                options={getOptionsByPath(NestedDatabucket, [USER_ISSUES, ISSUE_STATUS])}
                disabled
 
              />
            </Col>
            <Col span={5}>
              <label style={{ display: "block", marginBottom: "10px", fontWeight: "500" }}>
                Attachments
              </label>
 
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleMultipleAttachment}
                multiple
                style={{ display: "none" }}
              />
 
              <Link onClick={() => fileInputRef.current?.click()}>
                <i
                  className="fa-solid fa-file"
                  style={{ fontSize: "20px", marginRight: "10px" }}
                />
                Choose Files
              </Link>
 
              <div style={{ marginTop: 15 }}>
                {fileData?.length > 0 && (
                  <div>
                    {fileData.map((file, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "8px",
                          marginBottom: "5px",
                          backgroundColor: "#f5f5f5",
                          borderRadius: "4px",
                        }}
                      >
                        <span>{file.originalName}</span>
                        <span
                          style={{
                            cursor: "pointer",
                            color: "red",
                            fontWeight: "bold",
                            marginLeft: "10px",
                          }}
                          onClick={() =>
                            setFileData((prev) =>
                              prev.filter((_, i) => i !== index)
                            )
                          }
                        >
                          &times;
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Col>
 
            <Col span={12}>
              <TextareaField
                label={<>Task Description<span style={{ color: "red" }}>*</span></>}
                name="issuedescription"
                value={formData?.issuedescription}
                onChange={handleInputChange}
                rows="3"
              />
            </Col>
            <Col span={12}>
              <TextareaField
                label="Guide Notes"
                name="Instructions"
                value={formData?.Instructions}
                onChange={handleInputChange}
                rows="3"
              />
            </Col>
 
 
          </Row>
        </Card>
      </form>
    </div >
  );
};
 
export default AddIssueForm;
 
 